// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */

import * as RescriptRelay from "rescript-relay/src/RescriptRelay.re.mjs";

let Types = {};

function convertFragment(value) {
  return RescriptRelay.convertWithoutPlan(value, undefined);
}

let Internal = {
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "kind": "Literal",
  "name": "first",
  "value": 6
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sku",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomeFeaturedProducts_query",
  "selections": [
    {
      "alias": "custphotoreal",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "sku",
          "value": "custphotoreal"
        }
      ],
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "featuredOrdersBySku",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": "featuredOrdersBySku(first:6,sku:\"custphotoreal\")"
    },
    {
      "alias": "custwatercolor",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "sku",
          "value": "custwatercolor"
        }
      ],
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "featuredOrdersBySku",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": "featuredOrdersBySku(first:6,sku:\"custwatercolor\")"
    },
    {
      "alias": "custcharcoal",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "sku",
          "value": "custcharcoal"
        }
      ],
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "featuredOrdersBySku",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": "featuredOrdersBySku(first:6,sku:\"custcharcoal\")"
    },
    {
      "alias": "custpencil",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "sku",
          "value": "custpencil"
        }
      ],
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "featuredOrdersBySku",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": "featuredOrdersBySku(first:6,sku:\"custpencil\")"
    },
    {
      "alias": "custcoloredpencil",
      "args": [
        (v0/*: any*/),
        {
          "kind": "Literal",
          "name": "sku",
          "value": "custcoloredpencil"
        }
      ],
      "concreteType": "GalleryItem",
      "kind": "LinkedField",
      "name": "featuredOrdersBySku",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": "featuredOrdersBySku(first:6,sku:\"custcoloredpencil\")"
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})());

export {
  Types,
  Internal,
  Utils,
  node,
}
/* node Not a pure module */
